import { defineComponent, openBlock, createElementBlock, createElementVNode, toDisplayString } from "vue";
const _hoisted_1 = {
  id: "product-primary-description",
  class: "buy-box-product-description",
  "aria-label": "main product description"
};
const _hoisted_2 = {
  class: "buy-box-product-description__text"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "BuyBoxProductDescription",
  props: {
    description: {}
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("section", _hoisted_1, [createElementVNode("p", _hoisted_2, toDisplayString(_ctx.description), 1)]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=BuyBoxProductDescription2.mjs.map
